import React, { FunctionComponent } from "react"
import InfiniteScroll from "react-infinite-scroller"
import { useTranslation } from "react-i18next"

import noInvoicesImg from "assets/img/no-invoices.svg"

import Text from "components/Text/Text"
import Spinner from "components/Spinner/Spinner"
import Table, { TableColumn, TableHeaderTheme, TableRow, TableTheme } from "components/Table/Table"

interface IAssetInvoicesProps {
    tableColumns: TableColumn[]
    tableRows: TableRow[] | null
    tableHeaderTheme?: TableHeaderTheme
    tableTheme?: TableTheme
    loadNextPage(): Promise<void>
    isInitialLoad: boolean
    isLoading: boolean
    hasMore: boolean
    scrollEl?: React.RefObject<HTMLDivElement | null>
}

const AssetInvoices: FunctionComponent<React.PropsWithChildren<IAssetInvoicesProps>> = ({
    tableColumns,
    tableRows,
    tableHeaderTheme,
    tableTheme,
    loadNextPage,
    isInitialLoad,
    isLoading,
    hasMore,
    scrollEl,
}) => {
    const { t } = useTranslation()

    return (
        <>
            {!!tableRows && tableRows.length > 0 &&
                <InfiniteScroll
                    pageStart={0}
                    loadMore={loadNextPage}
                    initialLoad={isInitialLoad}
                    hasMore={hasMore}
                    getScrollParent={() => scrollEl?.current || null}
                    useWindow={false}>
                    <Table
                        headerTheme={tableHeaderTheme}
                        theme={tableTheme}
                        columns={tableColumns}
                        rows={tableRows} />
                </InfiniteScroll>
            }
            {isLoading &&
                <div className="py-4">
                    <Spinner />
                </div>
            }
            {tableRows && tableRows.length === 0 &&
                <div className="text-center py-4">
                    <img src={noInvoicesImg} alt="" className="mb-4" />
                    <Text type="p" className="white-space-pre-line">{t('invoices.noInvoicesAvailable')}</Text>
                </div>
            }
        </>
    )
}

export default AssetInvoices
